import { capitalizeAllIfLower } from '@btime/helpers'
import { compose, prop } from 'ramda'
import React from 'react'

import LazySelect from '../../../components/form/LazySelect'
import UsersLoader, { useUsers } from '../_load/UsersLoader'

const mapOptions = data =>
  data.map(item => ({
    origin: item,
    value: prop('id', item),
    label: compose(capitalizeAllIfLower, prop('name'))(item)
  }))

const UsersSelect = ({ filter, ...props }) => {
  return (
    <LazySelect Loader={UsersLoader} loaderProps={{ filter }} dataHook={useUsers} mapOptions={mapOptions} {...props} />
  )
}

export default UsersSelect
